export const fontCdn: string =
  "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Cinzel:wght@400..900&display=swap&family=Nanum+Brush+Script&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap";

// export const headlineFont: string = `NOIRetBLANC, Arial, sans-serif`;
export const headlineFont: string = `"Cinzel", serif`;
export const bodyFont: string = `"Montserrat", sans-serif`;
export const fontFamilies: string = `${headlineFont},${bodyFont}`;
``;
